import Image from "next/image";
import { site } from "@/lib/data";

export function BrandLogo({
  className,
  priority = false,
}: {
  className: string;
  priority?: boolean;
}) {
  return (
    <Image
      src={site.logo}
      alt={`${site.name} logo`}
      width={331}
      height={341}
      className={className}
      priority={priority}
      unoptimized
    />
  );
}
